import api from "./api";

export const ProblemsAPI = {
  list: () => api("/problems"),
  get: (id) => api(`/problems/${id}`),
  create: (data) =>
    api("/problems", { method: "POST", body: JSON.stringify(data) }),
  addUpdate: (id, data) =>
    api(`/problems/${id}/updates`, {
      method: "POST",
      body: JSON.stringify(data),
    }),
  linkTickets: (id, data) =>
    api(`/problems/${id}/tickets`, {
      method: "POST",
      body: JSON.stringify(data),
    }),
};